import styled from "styled-components";

export const RootContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const WebSdkContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;